<template>
	<div class="cms-content">
		<div class="segmented-control-wrapper">
			<div class="container-title">
				<h2 class="heading-2">{{ $t('Facilities') }}</h2>
				<ja-button
					v-if="showCreate"
					name="save"
					class="small"
					@click.native.prevent="onCreateNew"
					>{{ $t('createNew') }}</ja-button
				>
			</div>
			<!-- Table simulation Template -->
			<ja-facility-table
				v-if="showCreate && dataTableFacility"
				:data="dataTableFacility"
				@editRow="handleEditRow"
				@deleteRow="handleDeleteRow"
			></ja-facility-table>
			<!-- Create new Template -->
			<ja-create-new-facility
				v-if="!showCreate && dataEdit"
				:data-edit="dataEdit"
				@saveFacility="handleSaveSimulation"
				@cancel="handleCancel"
			></ja-create-new-facility>
		</div>
	</div>
</template>
<script>
import Button from '@/components/ui/Button';
import FacilityTable from './FacilityTable.vue';
import CreateNewFacility from './CreateNewFacility.vue';
import FacilityService from '@/services/cms/FacilityService';
import AdminFacility from '@/mixins/AdminFacility';

export default {
	components: {
		jaFacilityTable: FacilityTable,
		jaCreateNewFacility: CreateNewFacility,
		jaButton: Button
	},
	mixins: [AdminFacility],
	props: {},
	data() {
		return {
			showFacility: true,
			dataTableFacility: null,
			dataEdit: null
		};
	},
	computed: {
		showCreate() {
			return this.isEnable && this.showFacility;
		},
		isEnable() {
			return (
				this.selectedFacilityId == 0 && (this.isSuperAdmin || this.isUSAAdmin)
			);
		},
		isReturnOption() {
			return this.$store.state.isReturnOption;
		}
	},
	watch: {
		selectedFacility() {
			this.getMyView();
		},
		isReturnOption(newValue) {
			if (newValue === true) {
				this.showFacility = true;
			} else {
				this.showFacility = false;
			}
		}
	},
	mounted() {
		this.getMyView();
	},
	methods: {
		getMyView() {
			this.$store.commit('setLoading', true);
			if (this.isEnable) {
				this.showFacility = true;
				this.getFacility();
			} else {
				this.showFacility = false;
				this.$store.commit('setIsReturnOption', false);
				this.handleEditRow(this.selectedFacility);
			}
		},
		async getFacility() {
			const data = await FacilityService.getAll(this.selectedFacilityId);
			this.dataTableFacility = data;
			this.$store.commit('setLoading', false);
		},
		async onCreateNew() {
			const data = await FacilityService.getById();
			this.dataEdit = data;
			this.showFacility = false;
			this.$store.commit('setIsReturnOption', false);
		},
		async handleEditRow(rowData) {
			const data = await FacilityService.getById(rowData.facility_ID);
			this.dataEdit = data;
			this.showFacility = false;
			this.$store.commit('setLoading', false);
			this.$store.commit('setIsReturnOption', false);
		},
		async handleSaveSimulation(facility) {
			this.$store.commit('setLoading', true);
			await FacilityService.update(facility);
			await this.getFacility();
			this.showFacility = true;
		},
		async handleDeleteRow(rowData) {
			this.$store.commit('setLoading', true);
			await FacilityService.deleteById(rowData.facility_ID);
			await this.getFacility();
			this.showFacility = true;
		},
		async handleCancel() {
			if (this.isEnable) {
				this.$store.commit('setLoading', true);
				await this.getFacility();
				this.showFacility = true;
			}
		}
	}
};
</script>
<style lang="scss" scoped>
.container-title {
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.cms-content {
	margin: auto;
	max-width: 1000px;
	margin-top: 32px;
	margin-bottom: 32px;
}
</style>
